import React from "react"

import logo01 from "../images/companiesLogo/row1/logo01.png"
import logo02 from "../images/companiesLogo/row1/logo02.png"
import logo03 from "../images/companiesLogo/row1/logo03.png"
import logo04 from "../images/companiesLogo/row1/logo04.png"
import logo05 from "../images/companiesLogo/row1/logo05.png"
import logo06 from "../images/companiesLogo/row1/logo06.png"
import logo07 from "../images/companiesLogo/row1/logo07.png"
import logo08 from "../images/companiesLogo/row1/logo08.png"
import logo09 from "../images/companiesLogo/row1/logo09.png"
import logo10 from "../images/companiesLogo/row1/logo10.png"
import logo11 from "../images/companiesLogo/row1/logo11.png"
import logo12 from "../images/companiesLogo/row1/logo12.png"
import logo13 from "../images/companiesLogo/row1/logo13.png"
import logo14 from "../images/companiesLogo/row1/logo14.png"
import logo15 from "../images/companiesLogo/row1/logo15.png"

import logoRow2_01 from "../images/companiesLogo/row2/logoRow2_01.png"
import logoRow2_02 from "../images/companiesLogo/row2/logoRow2_02.png"
import logoRow2_03 from "../images/companiesLogo/row2/logoRow2_03.png"
import logoRow2_04 from "../images/companiesLogo/row2/logoRow2_04.png"
import logoRow2_05 from "../images/companiesLogo/row2/logoRow2_05.png"
import logoRow2_06 from "../images/companiesLogo/row2/logoRow2_06.png"
import logoRow2_07 from "../images/companiesLogo/row2/logoRow2_07.png"
import logoRow2_08 from "../images/companiesLogo/row2/logoRow2_08.png"
import logoRow2_09 from "../images/companiesLogo/row2/logoRow2_09.png"
import logoRow2_10 from "../images/companiesLogo/row2/logoRow2_10.png"
import logoRow2_11 from "../images/companiesLogo/row2/logoRow2_11.png"
import logoRow2_12 from "../images/companiesLogo/row2/logoRow2_12.png"
import logoRow2_13 from "../images/companiesLogo/row2/logoRow2_13.png"
import logoRow2_15 from "../images/companiesLogo/row2/logoRow2_15.png"

const RemoteTeams: React.FC<{
  showGoldenKitty: boolean
  showFeatured?: boolean
}> = ({ showGoldenKitty, showFeatured = false }) => {
  return (
    <div className="companies-container">
      {showGoldenKitty && (
        <div className="golden-kitty-badge">
          <a
            href="https://www.producthunt.com/posts/thursday?utm_source=badge-golden-kitty-badge&utm_medium=badge&utm_souce=badge-thursday"
            target="_blank"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/golden-kitty-badge.svg?post_id=317530&theme=light"
              alt="Thursday - Where&#0032;remote&#0032;teams&#0032;do&#0032;their&#0032;socials&#0044;&#0032;no&#0032;sign&#0032;up&#0032;required | Product Hunt"
              style={{ width: "250px", height: "54px" }}
              width="250"
              height="54"
            />
          </a>
        </div>
      )}

      {showFeatured && (
        <div className="golden-kitty-badge">
          <a
            href="https://www.producthunt.com/posts/conversations-by-thursday?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-conversations&#0045;by&#0045;thursday"
            target="_blank"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=336139&theme=light"
              alt="Conversations&#0032;by&#0032;Thursday - Time&#0032;for&#0032;new&#0032;social&#0032;rituals&#0032;for&#0032;your&#0032;remote&#0032;team | Product Hunt"
              style={{ width: "250px", height: "54px" }}
              width="250"
              height="54"
            />
          </a>
        </div>
      )}

      <div className="h3Text companies-header">
        The best remote teams love Thursday
      </div>
      <div className="logos-container">
        <div className="logo-row-wrapper">
          <div className="logo-row">
            <img src={logo01} alt="company-logo" />
            <img src={logo02} alt="company-logo" />
            <img src={logo03} alt="company-logo" />
            <img src={logo04} alt="company-logo" />
            <img src={logo05} alt="company-logo" />
            <img src={logo06} alt="company-logo" />
            <img src={logo07} alt="company-logo" />
            <img src={logo08} alt="company-logo" />
            <img src={logo09} alt="company-logo" />
            <img src={logo10} alt="company-logo" />
            <img src={logo11} alt="company-logo" />
            <img src={logo12} alt="company-logo" />
            <img src={logo13} alt="company-logo" />
            <img src={logo14} alt="company-logo" />
            <img src={logo15} alt="company-logo" />

            <img src={logo01} alt="company-logo" />
            <img src={logo02} alt="company-logo" />
            <img src={logo03} alt="company-logo" />
            <img src={logo04} alt="company-logo" />
            <img src={logo05} alt="company-logo" />
            <img src={logo06} alt="company-logo" />
            <img src={logo07} alt="company-logo" />
            <img src={logo08} alt="company-logo" />
          </div>
        </div>
        <div className="logo-row-wrapper">
          <div className="logo-row2">
            <img src={logoRow2_01} alt="company-logo" />
            <img src={logoRow2_02} alt="company-logo" />
            <img src={logoRow2_03} alt="company-logo" />
            <img src={logoRow2_04} alt="company-logo" />
            <img src={logoRow2_05} alt="company-logo" />
            <img src={logoRow2_06} alt="company-logo" />
            <img src={logoRow2_07} alt="company-logo" />
            <img src={logoRow2_08} alt="company-logo" />
            <img src={logoRow2_09} alt="company-logo" />
            <img src={logoRow2_10} alt="company-logo" />
            <img src={logoRow2_11} alt="company-logo" />
            <img src={logoRow2_12} alt="company-logo" />
            <img src={logoRow2_13} alt="company-logo" />
            <img src={logoRow2_15} alt="company-logo" />

            <img src={logoRow2_01} alt="company-logo" />
            <img src={logoRow2_02} alt="company-logo" />
            <img src={logoRow2_03} alt="company-logo" />
            <img src={logoRow2_04} alt="company-logo" />
            <img src={logoRow2_05} alt="company-logo" />
            <img src={logoRow2_06} alt="company-logo" />
            <img src={logoRow2_07} alt="company-logo" />
            <img src={logoRow2_08} alt="company-logo" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RemoteTeams
